// Re-runs the app's tooltip initializer over a subtree the panel just replaced.
// It is defined in application.js and owns the tippy defaults (theme, delay,
// sanitization), so binding tippy directly here would silently diverge from
// every other tooltip in the app.
export function initTooltips(root) {
  window.initializeTippy?.(root)
}
